import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'environments/environment';
import { getStoredAccessToken, httpHeader } from 'global/httpHeader';
import { exit } from 'process';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { appuser } from './app-user';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUser: BehaviorSubject<appuser>;
  baseurl = environment.apiURL;
  helper = new JwtHelperService();
  value: any;
  isLogined = false;
  username: string;
  dr = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private snack: MatSnackBar,
  ) {}
  ngOnInit() {}
  //User Login
  login(model: any) {
    model['source'] = 'WEB';
    return this.http.post(this.baseurl + 'auth/login', model).pipe(
      map(
        (response: any) => {
          const user = response;
          if (user) {
            this.isLogined = true;
            localStorage.setItem('id', user.bpId);
            localStorage.setItem('user_country', user.countryCode);
            localStorage.setItem('customerName', user.customerName);
            localStorage.setItem(
              'username',
              this.helper.decodeToken(getStoredAccessToken())['unique_name'],
            );
            // localStorage.setItem('ischangepwd', user.isChangePassword);
          }
        },
        (err) => {
          console.error(err);
        },
      ),
    );
  }

  logout() {
    this.isLogined = false;
    // localStorage.clear();
    localStorage.removeItem('userid');
  }

  getAuth(path?: any) {
    var model: any = {
      userid: parseInt(this.helper.decodeToken(httpHeader.token)['nameid']),
      state: path,
    };

    return this.http.post(this.baseurl + 'auth/getAuth', model).pipe(
      map((response: any) => {
        const rs = response;
        if (rs) {
          // this.profileService.getUser().subscribe(
          //   (res: any) => {
          //     localStorage.setItem('user', res.data);
          //   }
          // )
          return true;
        } else {
          this.snack.open(`You are not authorized to access this page!`, 'OK', {
            duration: 4000,
          });
          // this.router.navigate(['/v2/secure/signin']);
          this.router.navigate(['/secure/signin']);
        }
      }),
    );
  }
  checkIfAuth(path?: any) {
    var model: any = {
      state: path,
    };
    return this.http.post(this.baseurl + 'auth/getAuth', model).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  public currentUserValue() {
    var token = getStoredAccessToken();
    if (token != null) {
      return true;
    }

    return false;
  }
  async checkAuth(model: any) {
    return await this.http
      .post(this.baseurl + 'auth/getAuth', model)
      .pipe(map((response: any) => {}));
  }
  isLoggedIn() {
    return this.isLogined;
  }

  //Get general data
  async getData(controller: string, httpParams?: HttpParams) {
    const data = await this.http
      .get(this.baseurl + controller, httpHeader.httpOptions)
      .toPromise();
    return data as string[];
  }

  //Get header data
  async getColumns(data: any[], formname?: string) {
    //get column translate
    let f_arr_l = await this.getListLabel(formname);
    let thead: any[] = [];
    var arr = [
      {
        controll: 'id',
        ishidden: true,
      },
      {
        controll: 'isactive',
        ishidden: true,
      },
      {
        controll: 'createdby',
        ishidden: true,
      },
      {
        controll: 'createddate',
        ishidden: true,
      },
      {
        controll: 'modifiedby',
        ishidden: true,
      },
      {
        controll: 'modifieddate',
        ishidden: true,
      },
      {
        controll: 'isActive',
        ishidden: true,
      },
      {
        controll: 'passwordHash',
        ishidden: true,
      },
      {
        controll: 'passwordSalt',
        ishidden: true,
      },
      {
        controll: 'types',
        ishidden: true,
      },
      {
        controll: 'permissions',
        ishidden: true,
      },
      {
        controll: 'workflow',
        ishidden: true,
      },
      {
        controll: 'requesters',
        ishidden: true,
      },
      {
        controll: 'recipients',
        ishidden: true,
      },

      {
        controll: 'provinceid',
        ishidden: true,
      },
      {
        controll: 'workflowid',
        ishidden: true,
      },
      {
        controll: 'process_id',
        ishidden: true,
      },
      {
        controll: 'regionid',
        ishidden: true,
      },
      {
        controll: 'createdbyId',
        ishidden: true,
      },
      {
        controll: 'modifiedbyId',
        ishidden: true,
      },
      {
        controll: 'status',
        ishidden: true,
      },
    ];

    if (data.length > 0) {
      var f_arr: any[] = [];
      f_arr.push(data[0]);
      f_arr.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          //check if key is displayable
          var k = key.replace(/_/g, ' ');
          var label = k[0].toUpperCase() + k.slice(1);
          var isHidden = false;
          arr.forEach(function (ar) {
            if (ar.controll == key) {
              if (ar.ishidden) isHidden = true;
            }
          });
          //if column translate
          f_arr_l.forEach((obt) => {
            if (obt['field'] == key) label = obt['label'];
            exit;
          });
          let arr_key = {
            prop: key,
            name: label,
          };
          if (!isHidden) thead.push(arr_key);
        });
      });
    }
    return thead;
  }
  async getListLabel(tab: string) {
    const userString = localStorage.getItem('user') || '{}';

    const user = JSON.parse(userString);

    const data = await this.http
      .get(this.baseurl + 'datastructure/getlabel/?formname=ef_' + tab)
      .toPromise();
    return data as string[];
  }
  get employeeID(): string {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.userInfo?.employee_id ?? '';
  }
}
